import React from 'react';
import { Link } from 'react-router-dom';

const AboutUs = () => {
  return (
    <div className="min-h-screen ">
      {/* Header Section */}
      <header className=" p-6 text-center">
        <h1 className="text-4xl font-bold"><span className='text-[#FF6500]'>MindLoop</span> GPT</h1>
        <p className="mt-2 text-lg">Learn more about MindLoop GPT and our mission</p>
      </header>

      {/* Main Content */}
      <main className="p-6 space-y-12">
        {/* Our Mission Section */}
        <section id="mission">
          <h2 className="text-3xl font-bold border-b-2 border-[#FF6500] pb-2">Our <span className='text-[#FF6500]'>Mission</span></h2>
          <p className="mt-4">
            At MindLoop GPT, our mission is to empower developers and businesses with advanced AI technology that simplifies complex tasks, enhances productivity, and drives innovation. We strive to make AI accessible and easy to integrate, enabling the next generation of intelligent applications.
          </p>
        </section>

        {/* Our Vision Section */}
        <section id="vision">
          <h2 className="text-3xl font-bold border-b-2 border-[#FF6500] pb-2">Our <span className='text-[#FF6500]'>Vision</span></h2>
          <p className="mt-4">
            Our vision is to create a world where AI seamlessly integrates into everyday life, augmenting human capabilities and unlocking new possibilities. We aim to lead the charge in responsible AI development, ensuring that our technology benefits society while maintaining the highest ethical standards.
          </p>
        </section>

        {/* Our Values Section */}
        <section id="values">
          <h2 className="text-3xl font-bold border-b-2 border-[#FF6500] pb-2">Our <span className='text-[#FF6500]'>Values</span></h2>
          <ul className="mt-4 space-y-4">
            <li>
              <h3 className="text-2xl font-semibold">Innovation</h3>
              <p className="mt-2">
                We are committed to pushing the boundaries of what's possible with AI, constantly innovating to deliver cutting-edge solutions.
              </p>
            </li>
            <li>
              <h3 className="text-2xl font-semibold">Integrity</h3>
              <p className="mt-2">
                Integrity is at the core of everything we do. We believe in transparent, honest communication and ethical AI practices.
              </p>
            </li>
            <li>
              <h3 className="text-2xl font-semibold">Collaboration</h3>
              <p className="mt-2">
                We foster a culture of collaboration, both within our team and with our partners, to achieve the best possible outcomes.
              </p>
            </li>
            <li>
              <h3 className="text-2xl font-semibold">Customer Focus</h3>
              <p className="mt-2">
                Our customers' success is our success. We prioritize their needs and strive to deliver exceptional service and support.
              </p>
            </li>
          </ul>
        </section>

        {/* Our Team Section */}
        <section id="team">
          <h2 className="text-3xl font-bold border-b-2 border-[#FF6500] pb-2">Our <span className='text-[#FF6500]'>Team</span></h2>
          <p className="mt-4">
            The MindLoop GPT team is composed of talented developers, data scientists, and AI enthusiasts who are passionate about building innovative AI solutions. Together, we bring a diverse set of skills and experiences to the table, united by our shared goal of making AI more accessible and impactful.
          </p>
          {/* Team members' information can be added here */}
        </section>

        {/* Call to Action Section */}
        <section id="cta" className="text-center flex flex-col items-center">
          <h2 className="text-3xl font-bold">Join Us on Our Journey</h2>
          <p className="mt-4">
            We're excited about the future of AI and invite you to join us on this journey. Whether you're a developer, a business, or simply an AI enthusiast, there's a place for you at MindLoop GPT.
          </p>
          <button class="animated-button mt-4">
  <svg viewBox="0 0 24 24" class="arr-2" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"
    ></path>
  </svg>
  <Link to="/contact" ><span class="text">Contact Us</span></Link>
  <span class="circle"></span>
  <svg viewBox="0 0 24 24" class="arr-1" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"
    ></path>
  </svg>
</button>
        </section>
      </main>

      {/* Footer Section */}
      <footer className=" p-6 text-center">
        <p>&copy; 2024 MindLoop GPT. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default AboutUs;
